export default __webpack_public_path__ + "static/media/browser-wallet-dark.8a948cf3.svg";